export default {
  props: ['data']
}



// WEBPACK FOOTER //
// ./src/components/music/index.js